export const inboxFloatingSearchFadeStyle = {
  maskImage:
    "linear-gradient(to bottom, #000 0%, #000 42%, rgba(0,0,0,0.82) 62%, rgba(0,0,0,0.35) 82%, rgba(0,0,0,0.08) 94%, transparent 100%)",
  WebkitMaskImage:
    "linear-gradient(to bottom, #000 0%, #000 42%, rgba(0,0,0,0.82) 62%, rgba(0,0,0,0.35) 82%, rgba(0,0,0,0.08) 94%, transparent 100%)",
  maskSize: "100% 100%",
  WebkitMaskSize: "100% 100%",
  maskRepeat: "no-repeat",
  WebkitMaskRepeat: "no-repeat",
  backgroundImage:
    "linear-gradient(to bottom, hsl(var(--background) / 0.92) 0%, hsl(var(--background) / 0.55) 38%, hsl(var(--background) / 0.18) 68%, hsl(var(--background) / 0.04) 88%, transparent 100%)",
} as const

export const inboxFloatingSearchFadeLayerClassName =
  "pointer-events-none absolute inset-x-0 top-0 z-0 min-h-[5.25rem] w-full backdrop-blur-sm"
